import { Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import MediaCommentIcon from './MediaCommentIcon';
import DeleteIcon from 'components/DeleteIcon/DeleteIcon';
import { MediaGalleryFileInterface } from './MediaGallery';

const ThumbnailContainer = styled.div`
  height: 9.375rem;
  width: 9.375rem;
  cursor: pointer;
  position: relative;

  opacity: 0.85;

  video {
    object-fit: cover;
  }

  &:hover {
    opacity: 1;
  }
`;

const Thumbnail = styled.div<{ $src?: string; children?: any }>`
  background-image: url(${(props) => props.$src});
  height: 9.375rem;
  width: 9.375rem;
  cursor: pointer;
  background-position: center;
  background-size: cover;
  background-reat: no-repeat;
`;

const DeleteButton = styled(DeleteIcon)`
  position: absolute;
  top: 0.25rem;
  right: 0.25rem;

  &:hover {
    color: ${(props) => props.theme.colors.orange};
  }
`;

interface MediaGalleryThumbnailInterface {
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  file: MediaGalleryFileInterface;
  index: number;
  onClick: ({ file, index }: { file: MediaGalleryFileInterface; index: number }) => void;
  onClickDelete?: (file: MediaGalleryFileInterface) => void;
  hideComments?: boolean;
}

const MediaGalleryThumbnail = ({
  xs,
  sm,
  md,
  lg,
  xl,
  file,
  index,
  onClick,
  onClickDelete,
  hideComments,
}: MediaGalleryThumbnailInterface) => {
  const caption = file.link ? <Link to={file.link}>{file.caption}</Link> : file.caption;
  const type = file.fileType.substring(0, file.fileType.indexOf('/'));

  const ThumbnailComponent = useMemo(() => {
    return (
      <Grid key={file.url} item xs={xs ?? 12} sm={sm ?? 4} md={md ?? 3} lg={lg ?? 2} xl={xl ?? 2}>
        <ThumbnailContainer onClick={() => onClick({ file, index })}>
          {type === 'video' ? (
            <Thumbnail>
              <video width='100%' height='100%'>
                <source src={file.url} type='video/mp4' />
                Your browser does not support the video tag.
              </video>
            </Thumbnail>
          ) : (
            <Thumbnail $src={file.url} onClick={() => onClick({ file, index })} />
          )}
          {onClickDelete && <DeleteButton onClick={() => onClickDelete(file)} />}
          {!hideComments && <MediaCommentIcon commentCount={file.mediaComments?.length} />}
        </ThumbnailContainer>
        <small>{caption}</small>
      </Grid>
    );
  }, [hideComments ? file : file.mediaComments?.length]);

  return ThumbnailComponent;
};

export default MediaGalleryThumbnail;
